<template>
  <div>
    <application-modal v-if="visible">
      <div class="amb-modal-header py-1 d-flex justify-content-between">
        <div class="d-flex px-3 align-items-center">
          <h2 class="modal-title mb-0 mr-3">Rename</h2>
        </div>
        <div class="p-3 amb-close-modal" v-on:click="visible = false">
          <i class="fas fa-lg fa-times text-white"></i>
        </div>
      </div>

      <div class="container">
        <div
          class="row pt-0 amb-modal-body"
          style="max-height: 650px; -ms-overflow-y: auto; overflow-y: auto; overflow-x: hidden;"
        >
          <div class="row w-100 mx-1">
            <application-input class="col-12 my-3 input-belt" v-model="doc.filename">Filename</application-input>

            <div class="col-12 my-3">
              <button class="btn-green w-100" @click="update">Rename</button>
            </div>
          </div>
        </div>
      </div>
    </application-modal>
  </div>
</template>
<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true
    },
    document: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      visible: false,
      doc: null
    };
  },
  mounted() {
    this.doc = this.document;
  },
  watch: {
    open(newVal, oldVal) {
      this.visible = newVal;
    },
    visible(newVal, oldVal) {
      this.$emit("update:open", newVal);
    },
    document: {
      handler(newVal, oldVal) {
        this.doc = this.document;
      },
      deep: true
    }
  },
  methods: {
    async update() {
      try {
        let res = await axios.put(
          `/api/v2/applications/${this.$store.getters.initAppData.id}/documents/${this.document.id}`,
          {
            filename: this.doc.filename
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`
            }
          }
        );
        this.visible = false;
        this.$message({
          message: "Renamed",
          type: "success"
        });
      } catch (err) {
        console.error(err);
        this.visible = false;
        this.$message({
          message: "Rename error",
          type: "error"
        });
      }
    }
  }
};
</script>
